<template>
  <div>
    <v-dialog
        v-model="dialogDelete"
        persistent
        width="500"
    >
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Delete Affiliate Alert
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModal">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You are about to delete an affiliate alert:
          <div class="primary-color">
            {{ currentItem.name }} ?
          </div>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="copy-btn" @click="deleteItem()">
              YES, DELETE
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
        persistent
        v-model="dialogStatusToActive"
        width="700"
    >
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Show Alert on the Dashboard
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModalStatusToActive">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You are about to show this alert on the dashboard:

          <div class="green-text">
            {{ currentItem.name }}
          </div>
          This will also clear any existing "read" flags for affiliates.<br>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="green-btn" @click="statusToActive()">
              YES, I AM SURE
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
        v-model="dialogStatusToInActive"
        persistent
        width="700"
    >
      <v-card class="card-custom" style="background-color: #f5f5f5 !important;">
        <v-card-title>
          <v-row>
            <v-col cols="10" class="text-left text-h5 font-weight-bold" style="color: #3A3852">
              Hide Alert on the Dashboard
            </v-col>
            <v-col cols="2" class="text-right action">
              <span class="font-weight-bold text-h6" @click="closeModalStatusToInActive">
                 X
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-5 text-center font-weight-bold">
          You are about to hide this alert on thr Dashboard:<br> <br>
          <div class="red-text">
            {{ currentItem.name }} ?
          </div>
          if you reactivate this later, affiliates who read it will have to read it again <br>
          Are you sure?
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn class="red-btn" @click="statusToInActive()">
              YES, I AM SURE
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="search_btn_wrap flex v_center">
      <h1 class="mb-0 mr-4">Affiliate Alerts</h1>
      <v-btn
          color="primary"
          x-small
          :disabled="!isEditAccess"
          @click="showPopup = true, selectedItem = null"
          style="min-width: 0; min-height: 30px"
      >
        <span style="font-size: 24px">
          <i class="fas fa-plus"></i>
        </span>
      </v-btn>
    </div>

    <v-data-table
        :headers="table.headers"
        :items="getAffiliateAlerts.data"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :server-items-length="getAffiliateAlerts.count"
        :disable-sort="true"
        :footer-props="{ itemsPerPageOptions: table.pageOptions }"
        :items-per-page="table.perPage"
        :loading="table.loading"
        item-key="id"
        loading-text="Loading... Please wait"
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        fixed-header
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
    >
    <template v-slot:top>
      <DataTableTopBar @search="search"></DataTableTopBar>
    </template>

      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter type="items"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>

      <template v-slot:item.type="{ item }">
        <div class="tags-container">
          <v-chip
              :color="getColor(item.type)"
              class="ma-2"
              text-color="white">
            {{ getText(item.type) }}
          </v-chip>
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <v-switch
            v-model="item.status === 'active'"
            class="mr-2"
            :disabled="!isEditAccess"
            @change="handleStatusChange(item)"
            :title="item.status === 'active' ? 'Switch to inactive' : 'Switch to active'"
        ></v-switch>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon color="primary" :disabled="!isEditAccess" @click="editItem(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-btn icon color="primary" :disabled="!isEditAccess" @click="copyItem(item)">
          <v-icon> mdi-content-copy</v-icon>
        </v-btn>

        <v-btn icon color="primary" :disabled="!isEditAccess" @click="openModal(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>

        <v-btn icon color="primary" @click="history(item)">
          <v-icon>mdi-history</v-icon>
        </v-btn>
      </template>

    </v-data-table>
    <AffiliateAlertPopup
        :value="showPopup"
        :item="this.selectedItem ? this.selectedItem : null"
        v-if="showPopup"
        @close="showPopup = false"
        @createOrUpdateAlerts="handleCreateOrUpdateAlert"
    />

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import DataTableTopBar from "@/components/common/DataTableTopBar.vue";
import AffiliateAlertPopup from "@/components/pages/affiliates/affiliateAlerts/AffiliateAlertsPopup.vue";

export default {
  name: 'AffiliateAlerts',
  components: { AffiliateAlertPopup, DataTableTopBar },
  computed: {
    ...mapGetters('affiliateAlerts', ['getAffiliateAlerts','filters']),
    ...mapState('user', ['user']),
  },
  methods: {
    ...mapActions('affiliateAlerts', [
      'getAffiliateAlertsStore',
      'getAffiliateAlertsFilterDataStore',
      'createOrUpdateAffiliateAlertStore',
      'deleteAffiliateAlertStore',
    ]),
    search(searchText) {
      this.searchIn = searchText;
      this.submitFilter();
    },
    getColor(type) {
      switch(type) {
        case 'IMPORTANT_NOTIFICATION':
          return '#F45151';
        case 'BE_ADVISED':
          return '#F09738';
        case 'GOOD_TO_KNOW':
          return 'primary';
        default:
          return 'primary';
      }
    },
    getText(type) {
      switch(type) {
        case 'IMPORTANT_NOTIFICATION':
          return 'Important Notification';
        case 'BE_ADVISED':
          return 'Be Advised';
        case 'GOOD_TO_KNOW':
          return 'Good to Know';
        default:
          return type;
      }
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    handleStatusChange(item) {
      if (item.status === 'active') {
        item.status = 'inactive';
        this.currentItem = { ... item}

        this.dialogStatusToInActive = true;
      } else {
        item.status = 'active';
        this.currentItem = { ... item}
        this.dialogStatusToActive = true;
      }
    },
    async getFiltersData() {
      Object.keys(this.table.filters).forEach(name => {
        if (this.filters[name]) {
          this.table.filters[name]['data'] = this.filters[name];
          if (this.table.filters[name]['isRange']) {
            this.table.filters[name].min = Number(this.filters[name].find(f => f.key === 'min')['value']);
            this.table.filters[name].max = Number(this.filters[name].find(f => f.key === 'max')['value']);
          }
        }
        this.table.filters[name].data = this.filters[name]
      })
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.searchIn.length > 0) ? this.searchIn : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `'${this.table.filters[name].selected.join('\',\'')}'` :
            null;
      }
      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    async copyItem(item) {
      let copyItem = { ...item };
      copyItem.id = null;

      let baseName = item.name.replace(/(\s*-?\s*Copy\s*\d*)?$/, '');
      let copyNumber = 1;
      let copyName = `${baseName} - Copy`;

      while (true) {
        let existingCopy = await this.checkIfCopyExists(copyName);
        if (!existingCopy) {
          copyItem.name = copyName;
          copyItem.status = 'inactive';
          copyItem.user = this.user[0].email.split("@")[0];
          await this.createOrUpdateAffiliateAlertStore(copyItem);
          break;
        } else {
          copyName = `${baseName} - Copy ${copyNumber++}`;
        }
      }
    },

    checkIfCopyExists(name) {
      return this.getAffiliateAlerts.data.some(item => item.name === name);
    },
    async editItem(item) {
      this.selectedItem = item;
      this.showPopup = true;
      return this.selectedItem;
    },
    closeModal() {
      this.dialogDelete = false;
    },
    async openModal(item) {
      this.currentItem = { ... item}
      this.dialogDelete = true;
    },
    closeModalStatusToActive() {
      this.currentItem.status = 'inactive';

      this.getAffiliateAlerts.data.forEach((item, index) => {
        if (item.id === this.currentItem.id) {
          this.getAffiliateAlerts.data[index].status = 'inactive';
        }
      });
      this.dialogStatusToActive = false;
    },
    closeModalStatusToInActive() {
      this.currentItem.status = 'active';
      this.getAffiliateAlerts.data.forEach((item, index) => {
        if (item.id === this.currentItem.id) {
          this.getAffiliateAlerts.data[index].status = 'active';
        }
      });
      this.dialogStatusToInActive = false;

    },
    async statusToActive() {
      this.currentItem.status = 'active';
      this.currentItem.isEdit = true;
      this.currentItem.user = this.user[0].email.split("@")[0];
      await this.createOrUpdateAffiliateAlertStore(this.currentItem);

      this.dialogStatusToActive = false;
    },
    async statusToInActive() {
      this.currentItem.status = 'inactive';
      this.currentItem.isEdit = true;
      this.currentItem.user = this.user[0].email.split("@")[0];
      await this.createOrUpdateAffiliateAlertStore(this.currentItem);
      this.dialogStatusToInActive = false;
    },
    async deleteItem() {
      await this.deleteAffiliateAlertStore(this.currentItem.id);
      this.dialogDelete = false;
    },
    async history(item) {
      await this.$router.push(`/affiliates/alerts/history/${item.id}`);
    },
    async handleCreateOrUpdateAlert(alertData) {
      alertData.user = this.user[0].email.split("@")[0];
      await this.createOrUpdateAffiliateAlertStore(alertData);
      this.showPopup = false;
    },
    async getTableData() {
      this.table.loading = true
      const filters = await this.getFilters();
      await this.getAffiliateAlertsStore({
        filters,
        limit: this.table.perPage,
        page: this.table.currentPage,
        orderBy: this.table.orderBy,
        orderDirectionAsc: this.table.sortColumnsAsc,
      });
      this.table.loading = false
    },
    async updateTablePagination(params){
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      await this.getTableData()
    },
  },
  data() {
    return {
      typeItems: [
        { type: 'IMPORTANT_NOTIFICATION' },
        { type: 'BE_ADVISED' },
        { type: 'GOOD_TO_KNOW' },
      ],
      searchIn: '',
      dialogDelete: false,
      dialogStatusToActive: false,
      dialogStatusToInActive: false,
      currentItem: [],
      showPopup: false,
      selectedItem: null,
      isEditAccess: false,
      table: {
        heightCounter: 48,
        loading: false,
        awaitingSearch: false,
        currentPage: 1,
        itemsPerPage: 25,
        pageChangedByMe: false,
        pageOptions: [25, 50, 100],
        orderBy: 'id',
        sortColumnsAsc: true,
        headers: [
          { text: 'ID', value: 'id' },
          { text: 'Name', value: 'name' },
          { text: 'Type', value: 'type' },
          { text: 'Status', value: 'status' },
          { text: 'Message', value: 'message' },
          { text: 'Last Updated At', value: 'dateUpdated' },
          { text: 'Last Updated By', value: 'user' },
          { text: 'Actions', value: 'actions', align: 'center', sortable: false },
        ],
        filters: {
          id: {active: false, selected: [], show: false, property: '', data: []},
          name: {active: false, selected: [], show: false, property: '', data: []},
          type: {active: false, selected: [], show: false, property: '', data: []},
          message: {active: false, selected: [], show: false, property: '', data: []},
          status: {active: false, selected: [], show: false, property: '', data: []},
        }
      },
      tableHeaders: [

      ],
    };
  },
  async mounted() {
    if (this.user[0].can('manage_dashboard_alerts')){
      this.isEditAccess = true;
    }
    await this.getTableData()
    await this.getAffiliateAlertsFilterDataStore();
    await this.getFiltersData()

  },
};
</script>

<style lang="sass">
.red-switch .v-input--selection-controls__input
  border-color: red

.red-btn
  color: white !important
  background-color: #F45151 !important

.red-text
  color: #F45151 !important

.green-btn
  color: white !important
  background-color: #358D83 !important

.green-text
  color: #358D83 !important
</style>
